export default "__VITE_ASSET__Bj0hh6nY__ 800w, __VITE_ASSET__BD$jdMNi__ 1280w, __VITE_ASSET__D3P9qcX4__ 1920w";